<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-card title="유해위험기계기구 기본정보" :collapsed="true" class="cardClassDetailInfo">
        <template slot="card-detail">
          <div v-if="equipInfo.emplacementPlace" class="col-4">
            <c-label-text title="설비위치" :value="equipInfo.emplacementPlace"></c-label-text>
          </div>
          <div v-if="equipInfo.machineryClassification" class="col-4">
            <c-label-text title="설비종류" :value="equipInfo.machineryClassification"></c-label-text>
          </div>
          <div v-if="equipInfo.machineryName" class="col-4">
            <c-label-text title="형식(규격)" :value="equipInfo.machineryName"></c-label-text>
          </div>
        </template>
      </c-card>
      <c-table
        ref="table"
        title="유해위험기계기구 중점점검 이력"
        tableId="hazardEquipmentHis"
        :columns="grid.columns"
        :gridHeight="grid.height"
        :data="grid.data"
        :usePaging="false"
        @linkClick="linkClick"
      >
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'hazard-equipment-history',
  props: {
    tabParam: {
      type: Object,
      default: () => ({
        hhmHazardousMachineryId: '',
      }),
    },
  },
  data() {
    return {
      editable: true,
      equipInfo: {
        machineryClassificationName: '',
        machineryName: '',
        emplacementPlace: '',
      },
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      grid: {
        columns: [
          {
            name: "machineryTypeName",
            field: "machineryTypeName",
            label: "유형",
            style: 'width:100px', 
            align: "center",
            sortable: true,
          },
          {
            name: "focusName",
            field: "focusName",
            label: "점검명",
            style: 'width:300px', 
            align: "left",
            sortable: true,
            type: "link",
          },
          {
            name: "inspectionDate",
            field: "inspectionDate",
            label: "점검일",
            style: 'width:120px', 
            align: "center",
            sortable: true,
          },
          {
            name: "inspectionUserName",
            field: "inspectionUserName",
            label: "점검자",
            style: 'width:100px', 
            align: "center",
            sortable: true,
          },
          {
            name: "completeFlagName",
            field: "completeFlagName",
            label: "완료여부",
            style: 'width:120px', 
            align: "center",
            sortable: true,
          },
        ],
        height: '600px',
        data: [],
      },
      isSave: false,
      checkCdItems: [], // 검사결과
      listUrl: '',
      getStdUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    Object.assign(this.$data, this.$options.data());
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.sop.hhm.hazard.focus.info.list.url;
      this.getStdUrl = selectConfig.sop.hhm.hazard.check.get.url;
      this.getStandardInfo();
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {hhmHazardousMachineryId: this.tabParam.hhmHazardousMachineryId};
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    getStandardInfo() {
      if (this.tabParam.hhmHazardousMachineryId) {
        this.$http.url = this.$format(this.getStdUrl, this.tabParam.hhmHazardousMachineryId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.equipInfo = this.$_.clone(_result.data);
        },);
      }
    },
    linkClick(row) {
      this.popupOptions.title = "중점점검 결과 상세"; // 중점점검 결과 상세
      this.popupOptions.param = {
        focusInspectionId: row ? row.focusInspectionId : '',
      };
      this.popupOptions.target = () =>
        import(`${"./hazardFocusInspectionDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.height = '300px';
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>